import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { appName } from './lib/app-surface';
import { applyLanguage } from './i18n/translator';
import { ATLAS_LANGUAGES, LANGUAGE_STORAGE_KEY, type AtlasLanguage } from './lib/language-context';

document.title = appName;

const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
const language = ATLAS_LANGUAGES.some((option) => option.value === stored) ? (stored as AtlasLanguage) : 'en';
// Load the saved language before the first render so the interface does not appear in English first.
const ready = Promise.race([applyLanguage(language), new Promise((resolve) => window.setTimeout(resolve, 1500))]);

void ready.then(() =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  ),
);
